module.exports = __webpack_public_path__ + "img/pricing_3.1eb3dc66.png";